






















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import SimpleHeader from '@/modules/shared/components/shared/SimpleHeader.vue'
import AdminDepositShowTabular from '@/modules/deposit/components/admin/AdminDepositShowTabular.vue'
import {
  DepositPayableType,
  DepositResourceType,
  DepositSettlementType,
  DepositStatus
} from '@/modules/deposit/models/deposit-resource.model'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import TesDatePicker from '@/modules/shared/components/shared/kit/TesDatePicker.vue'
import { DateHelper } from '@/modules/shared/helpers/date'
import CopyableText from '@/modules/shared/components/shared/CopyableText.vue'
import MediaUploader from '@/modules/media/components/shared/MediaUploader.vue'
import AdminDepositCreateForm from '@/modules/deposit/components/admin/AdminDepositCreateForm.vue'
import { DepositCreateUseCase } from '@/modules/deposit/use-cases/admin/deposit-create.use-case'
import { BankAccountType } from '@/modules/bank-account/models/bank-account-resource.model'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'ایجاد واریزی جدید'
  },
  metaInfo: {
    title: 'ایجاد واریزی جدید'
  },
  components: {
    AdminDepositCreateForm,
    MediaUploader,
    CopyableText,
    TesDatePicker,
    BaseSelect,
    CurrencyInput,
    AdminDepositShowTabular,
    SimpleHeader,
    AdminUserInfoButton,
    BaseCard,
    BaseInput,
    BaseButton,
    PriceView,
    Toggle
  }
})
export default class CreatePage extends Vue {
  constructor(
    private readonly depositCreateUseCase: DepositCreateUseCase,
    private readonly dateHelper: DateHelper
  ) {
    super()
  }


  @Prop() depositData!: DepositResourceType //todo DepositCreateResourceType
  private deposit: DepositResourceType = this.initData()

  initData() {
    this.$set(this.depositData, 'data', {
      bank_account: {},
      reception_image: [],
      status: DepositStatus.PENDING,
      account_type: BankAccountType.NATURAL_PERSON,
      settlement_type: DepositSettlementType.CARD,
      payable_type: DepositPayableType.MANUAL
    })
    return this.depositData
  }

  onSubmit() {
    this.depositCreateUseCase.execute(this.deposit.data)
  }

  onDestroy() {
    //this.service.destroy(this.deposit.data.id)
  }

}
